// extracted by mini-css-extract-plugin
module.exports = {"header":"modal_header__Sb4sc","container":"modal_container__3WKEk"};